export const reuseAbleColor = {
  pupple: "#984779",
};
